
import { cn } from "@/lib/utils";

function InitialsPill({
  initials,
  color,
  size = "md",
}: {
  initials: string;
  color: string;
  size?: "sm" | "md";
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-grid shrink-0 place-items-center rounded-2xl bg-gradient-to-br font-semibold text-white",
        size === "sm" ? "h-8 w-8 text-xs" : "h-10 w-10 text-sm",
        color,
      )}
    >
      {initials || "?"}
    </span>
  );
}

export { InitialsPill };
